module.exports = __webpack_public_path__ + "img/hiking005.6fd91f33.jpg";